import CrudRequest from '@rootCommon/services/crud-request';
import { FHQ_GENERAL_SETTING } from '@rootCommon/constants/end-points';
import { FhqGeneralSetting, FhqGeneralSettingDto } from '@rootCommon/types/fhq';
import { IdType } from '@rootCommon/types/common';
import { ADMIN } from '@rootCommon/constants/common';

const FHQ_GENERAL_SETTING_ADMIN = `${FHQ_GENERAL_SETTING}/${ADMIN}`;

class FhqGeneralSettingService extends CrudRequest<FhqGeneralSetting, FhqGeneralSettingDto> {
  constructor() {
    super(FHQ_GENERAL_SETTING_ADMIN);
  }

  getListBySiteId = async (siteId: IdType): Promise<FhqGeneralSetting> => {
    const res = await CrudRequest.get<FhqGeneralSetting>(FHQ_GENERAL_SETTING_ADMIN, {
      params: { siteId },
    });

    return res.data;
  };
}

export default new FhqGeneralSettingService();
